/***
 * @file: ç»å®è´¦æ·
 * @Date: 2020-09-02 11:07:04
 * @author: manyao.zhu
 */
import { Component, ElementRef, OnInit } from '@angular/core';

import { DomSanitizer } from '@angular/platform-browser';

import { Data } from './config';

@Component({
  selector: 'dt-bind-account',
  templateUrl: './bind-account.component.html',
  styleUrls: ['./bind-account.component.scss'],
})
export class BindAccountComponent implements OnInit {
  isVisible = false;
  accountList: any[] = [];
  visibleBindModal = false;
  getHtml: any;

  link: any;

  constructor(private el: ElementRef, private sanitizer: DomSanitizer) {}

  ngOnInit() {
    this.getAccountList();
  }

  // è·ååè¡¨
  getAccountList() {
    this.accountList = Data;
    this.accountList.forEach((item) => {
      if (item.bindFlag === '1') {
        item.open = true;
      }
    });
  }

  open() {
    this.isVisible = true;
  }

  handleCancel() {
    this.isVisible = false;
  }

  toggleExpand(item) {
    item.open = !item.open;
  }

  // ç»å®çåæ¢äºä»¶
  exchangeBind(item) {
    if (item.bindFlag === '1') {
      this.unbindAcccount(item);
      return;
    }
    this.bindAccount(item);
  }

  // è§£é¤ç»å®æä½
  unbindAcccount(item) {}

  // ç»å®æä½
  bindAccount(item) {
    this.visibleBindModal = true;
    setTimeout(() => {
      // éé£ä¹¦çç»å½æ¹å¼
      if (!item.windowOpenUri) {
        this.bindThirdLogin(item);
        return;
      }
      this.bindFeishuLogin(item);
    }, 10);
  }

  // éé£ä¹¦ç¬¬ä¸æ¹ç»å®
  bindThirdLogin(item) {
    const script = document.createElement('script');
    script.src = item.scriptUrl;
    this.el.nativeElement.querySelector('.bind-modal-content').setAttribute('id', item.authKind);
    document.body.appendChild(script);
    setTimeout(() => {
      const obj = eval(item.scriptConfig);
    }, 100);
  }

  // é£ä¹¦ç»å®
  bindFeishuLogin(item) {
    const iframe = document.createElement('iframe');
    iframe.width = '100%';
    iframe.height = '100%';
    iframe.style.marginBottom = '140px';
    this.link = item.windowOpenUri;
    this.link = this.truck(this.link);
    iframe.src = this.link.changingThisBreaksApplicationSecurity;
    this.el.nativeElement.querySelector('.bind-modal-content').appendChild(iframe);
  }

  // å³é­ç»å®
  closeVisible() {
    this.visibleBindModal = false;
  }

  // iframeçä¿¡ç¨è¿æ»¤
  truck(link): any {
    return this.sanitizer.bypassSecurityTrustResourceUrl(link);
  }
}
